import { useEffect, useState, useMemo } from 'react'
import {
  Checkbox,
  FormControl,
  FormLabel,
  InputBase,
  MenuItem,
  Select
} from '@material-ui/core'
import { Search } from 'lucide-react'
import toastError from '../../errors/toastError'
import api from '../../services/api'
import { useStyles } from './style'

const ALL_VALUE = 'all'

export function UsersFilter({
  onFiltered,
  initialUsers = [],
  excludeId,
  label = 'Usuários'
}) {
  const classes = useStyles()
  const [users, setUsers] = useState([])
  const [selecteds, setSelecteds] = useState([])
  const [searchParam, setSearchParam] = useState('')

  useEffect(() => {
    const loadUsers = async () => {
      try {
        const { data } = await api.get(`/users/list`)
        const userList = data
          .map(u => ({ id: u.id, name: u.name }))
          .filter(u => !excludeId || u.id !== excludeId)
        setUsers(userList)
      } catch (err) {
        toastError(err)
      }
    }
    loadUsers()
  }, [excludeId])

  // Sincroniza valor inicial apenas uma vez
  useEffect(() => {
    if (initialUsers.length > 0 && users.length > 0 && selecteds.length === 0) {
      const initial = initialUsers
        .map(init => users.find(u => u.id === init.id))
        .filter(Boolean)
      setSelecteds(initial)
    }
  }, [initialUsers, users])

  const isAllSelected = useMemo(() => {
    return users.length > 0 && selecteds.length === users.length
  }, [selecteds, users])

  const filteredUsers = users.filter(user =>
    user.name?.toLowerCase().includes(searchParam.toLowerCase())
  )

  const selectedIds = selecteds.map(user => user.id)

  const handleChange = event => {
    const value = event.target.value
    const clickedAll = value.includes(ALL_VALUE)

    let newSelection
    if (clickedAll) {
      newSelection = isAllSelected ? [] : users
    } else {
      newSelection = users.filter(user => value.includes(user.id))
    }

    setSelecteds(newSelection)
    onFiltered(newSelection)
  }

  const selectValue = isAllSelected ? [ALL_VALUE, ...selectedIds] : selectedIds

  const renderValue = () => {
    if (selecteds.length === 0) return 'Selecione'
    if (isAllSelected) return 'TODOS'
    const text = selecteds.map(option => option.name).join(', ')
    return (
      <span className={classes.selectedText} title={text}>
        {text}
      </span>
    )
  }

  return (
    <FormControl fullWidth className={classes.formControl}>
      <FormLabel>{label}</FormLabel>
      <Select
        multiple
        displayEmpty
        variant="outlined"
        value={selectValue}
        onChange={handleChange}
        renderValue={renderValue}
        MenuProps={{
          anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
          transformOrigin: { vertical: 'top', horizontal: 'left' },
          getContentAnchorEl: null,
          classes: { paper: classes.menuPaper }
        }}
      >
        <div
          className={classes.searchBox}
          onClick={event => event.stopPropagation()}
          onKeyDown={event => event.stopPropagation()}
        >
          <Search size={16} />
          <InputBase
            className={classes.searchInput}
            placeholder="Pesquisar usuário"
            value={searchParam}
            onChange={e => setSearchParam(e.target.value)}
            onClick={event => event.stopPropagation()}
            onKeyDown={event => event.stopPropagation()}
            autoFocus
          />
        </div>
        <MenuItem value={ALL_VALUE}>
          <Checkbox
            className={classes.checkbox}
            checked={isAllSelected}
            size="small"
            color="primary"
          />
          TODOS
        </MenuItem>
        {filteredUsers.map(user => (
          <MenuItem key={user.id} value={user.id}>
            <Checkbox
              className={classes.checkbox}
              checked={selectedIds.includes(user.id)}
              size="small"
              color="primary"
            />
            {user.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
